<template>
  <v-card class="filter-panel" elevation="0">
    <h1 class="filter-title">Salidas</h1>
    <v-form @submit.prevent="applyFilters" @keydown.enter.prevent="applyFilters">
    <v-row dense>
      <v-col cols="12" sm="6" md="3">
        <v-text-field v-model="filters.dateFrom" label="Fecha desde" type="date" variant="outlined" density="comfortable" />
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-text-field v-model="filters.dateTo" label="Fecha hasta" type="date" variant="outlined" density="comfortable" />
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-select v-model="filters.grainTypeId" label="Tipo de mercaderia" :items="grainTypes" item-title="name" item-value="id" clearable variant="outlined" density="comfortable" />
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-select v-model="filters.receiverId" label="Destinatario" :items="companies" item-title="name" item-value="id" clearable variant="outlined" density="comfortable" />
      </v-col>
    </v-row>
    <div class="filter-actions">
      <v-btn color="secondary" type="button" variant="tonal" @click="clearFilters">Limpiar filtros</v-btn>
      <v-btn color="primary" type="submit">Filtrar</v-btn>
    </div>
    </v-form>
  </v-card>
</template>
<script>

export default {
  name: 'FilterOutcomeForm',
  data: () => ({
    filters: { dateFrom: '', dateTo: '', grainTypeId: null, receiverId: null },
    grainTypes: [],
    companies: []
  }),
  async created () {
    await this.$store.dispatch('typesModule/getGrainTypes')
    await this.$store.dispatch('companyModule/getBaseCompanies')
    this.grainTypes = this.$store.getters['typesModule/getGrainTypes']
    this.companies = this.$store.getters['companyModule/getBaseCompanies']
  },
  methods: {
    applyFilters () {
      this.$store.dispatch('outcomeModule/filterItems', this.filters)
    },
    clearFilters () {
      this.filters = { dateFrom: '', dateTo: '', grainTypeId: null, receiverId: null }
      this.$store.dispatch('outcomeModule/refreshFilteredOutcomes')
    }
  }
}
</script>
